import { AcademyModel } from '@modules/academy/academy-model';

const { fields } = AcademyModel;

export default [
  fields.name,
  fields.propertyOwner,
];
